// import React from 'react';
// import styled from 'styled-components';
// import { Fade, AttentionSeeker } from "react-awesome-reveal";

// // --- Styled Components ---

// const Container = styled.section`
//   width: 100%;
//   padding: 40px 0;
//   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
// `;

// const HeaderTitle = styled.h2`
//   padding-left: 20px;
//   font-size: 1.2rem;
//   font-weight: 600;
//   color: #333;
//   text-transform: uppercase;
//   margin-bottom: 30px;
//   max-width: 1200px;
//   margin-inline: auto;
// `;

// const ObjectiveBanner = styled.div`
//   background-color: #8a3ffc; // The vibrant purple from the image
//   color: white;
//   padding: 60px 20px;
//   margin-bottom: 15px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   text-align: center;
//   width: 100%;
// `;

// const BannerTitle = styled.h3`
//   font-size: 1.1rem;
//   font-weight: 700;
//   margin: 0 0 15px 0;
//   text-transform: uppercase;
//   letter-spacing: 1px;
// `;

// const BannerDescription = styled.p`
//   font-size: 0.85rem;
//   max-width: 800px;
//   line-height: 1.6;
//   margin: 0;
//   font-weight: 400;
// `;

// // --- Data ---

// const objectives = [
//   {
//     title: "Our Vision",
//     description: "Employing human and material resources for construction and mapping services delivery as a world class company with highest standard of efficiency and integrity."
//   },
//   {
//     title: "Our Goal",
//     description: "To achieve and maintain a leadership position as a world class engineering and surveying company, known and respected for the quality of our work and the character of our staff."
//   },
//   {
//     title: "Quality Policy",
//     description: "It is the policy of PADEC to provide clients with products and services that conform to requirements meet client's needs, exceed client expectations, and are delivered timely in a cost-effective manner."
//   }
// ];

// // --- Component ---

// const CorporateObjectives = () => {
//   return (
//     <Container>
//       <Fade triggerOnce>
//         <HeaderTitle>Our Corporate Objectives</HeaderTitle>
//       </Fade>

//       {objectives.map((obj, index) => (
//         <Fade 
//           key={index} 
//           triggerOnce 
//           direction="up" 
//           delay={index * 100}
//         >
//           <ObjectiveBanner>
//             <BannerTitle>{obj.title}</BannerTitle>
//             <BannerDescription>{obj.description}</BannerDescription>
//           </ObjectiveBanner>
//         </Fade>
//       ))}
//     </Container>
//   );
// };

// export default CorporateObjectives;


import React from 'react';
import styled from 'styled-components';
import { Fade } from "react-awesome-reveal";

// --- Styled Components ---

const Container = styled.section`
  width: 100%;
  padding: 10px 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f9f9f9;
`;

const HeaderTitle = styled.h2`
  padding: 0 20px;
  font-size: 1.5rem;
  font-weight: bold;
  color: #439E6D;
  text-transform: uppercase;
  margin-bottom: 5px;
  max-width: 1200px;
  margin-inline: auto;
`;

/* The Perspective Wrapper */
const FlipCard = styled.div`
  background-color: transparent;
  width: 100%;
  height: 150px; /* Adjust height as needed */
  perspective: 1000px;
  margin-bottom: 15px;
  cursor: pointer;
`;

/* The container that actually rotates */
const FlipCardInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;

  ${FlipCard}:hover & {
    transform: rotateY(180deg);
  }
`;

/* Shared properties for both faces */
const CardFace = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
`;

const FrontFace = styled(CardFace)`
  background-color: #8a3ffc;
  color: white;
`;

const BackFace = styled(CardFace)`
  background-color: #6a2bc4; // Slightly darker purple for contrast
  color: white;
  transform: rotateY(180deg);
`;

const BannerTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const BannerDescription = styled.p`
  font-size: 1.1rem;
  max-width: 850px;
  line-height: 1.5;
  margin: 0;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.1;
  max-width: 800px;
`;

// --- Data ---

const objectives = [
  {
    title: "Our Vision",
    description: "Employing human and material resources for construction and mapping services delivery as a world class company with highest standard of efficiency and integrity.",
    backTitle: "Our Mission",
    backContent: (
      <List>
        <li>• Achieve excellent quality of services</li>
        <li>• Operate our business in an efficient, enterprising, safe, and innovative manner</li>
        <li>• Create value for our shareholders, clients, and employee.</li>
      </List>
    )
  },
  {
    title: "Our Goal",
    description: "To achieve and maintain a leadership position as a world class engineering and surveying company, known and respected for the quality of our work and the character of our staff.",
    backTitle: "Our Values",
    backContent: "At PGSL, we feel that every man-hour spent should make you money and give satisfaction. We believe in hiring – and keeping – good people, people who strive not just to do a good job, but also to do what’s right and ethical."
  },
  {
    title: "Quality Policy",
    description: "It is the policy of PADEC to provide clients with products and services that conform to requirements meet client's needs, exceed client expectations, and are delivered timely in a cost-effective manner.",
    backTitle: "Quality Objectives",
    backContent: "Provision of adequate resources and ensuring work is carried out to defined policies, procedures and instructions with an emphasis on continual process improvement."
  }
];

// --- Component ---

const CorporateObjectives = () => {
  return (
    <Container>
      <Fade triggerOnce>
        <HeaderTitle>Our Corporate Objectives</HeaderTitle>
      </Fade>

      {objectives.map((obj, index) => (
        <Fade 
          key={index} 
          triggerOnce 
          direction="up" 
          delay={index * 150}
        >
          <FlipCard>
            <FlipCardInner>
              {/* FRONT */}
              <FrontFace>
                <BannerTitle>{obj.title}</BannerTitle>
                <BannerDescription>{obj.description}</BannerDescription>
              </FrontFace>

              {/* BACK */}
              <BackFace>
                <BannerTitle>{obj.backTitle}</BannerTitle>
                <BannerDescription as="div">{obj.backContent}</BannerDescription>
              </BackFace>
            </FlipCardInner>
          </FlipCard>
        </Fade>
      ))}
    </Container>
  );
};

export default CorporateObjectives;